var map = {
	"./placeholder_add_audio.svg": 87583,
	"./placeholder_add_image.svg": 24114,
	"./placeholder_add_video.svg": 93184,
	"./placeholder_ai_assisted.svg": 94226,
	"./placeholder_record_audio.svg": 75239,
	"./placeholder_record_screen.svg": 76151,
	"./placeholder_record_video.svg": 41352,
	"./placeholder_select_content.svg": 35925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64723;